import script from "./ReportsAccountsTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportsAccountsTab.vue?vue&type=script&setup=true&lang=ts"

import "./ReportsAccountsTab.vue?vue&type=style&index=0&id=71cf98f4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71cf98f4"]])

export default __exports__